import { Helmet } from 'react-helmet-async'
import { site } from '../lib/metadata'

export default function PageHead({ title, description, canonical }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical || `${site.url}/`} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  )
}
